import React, { useEffect, useState } from 'react'
import "./style.css"
import { RiAddCircleLine, RiCloseLine, RiEdit2Line } from "react-icons/ri";
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { GET_EMAILS, GET_LOGS, GET_NATION, GET_ONE_NATION, GET_SCHEDULES, GET_USER } from '../graphql/query';
import { CREATE_LOG, CREATE_NATION, CREATE_SCHEDULE, NATION_UPDATE, UPDATE_ANUALS } from '../graphql/mutation';
import moment from 'moment';
import { toast } from 'react-toastify';

export default function Nation({ user }) {
    const [year, setYear] = useState("2025")
    const [selectId, setSelect] = useState(null)
    const [edit, setEdit] = useState(false)
    const [open, setOpen] = useState(false)
    const [area, setArea] = useState("")
    const [region, setRegion] = useState("")
    const [acend, setAcend] = useState(true)
    const [mail, setMail] = useState(false)

    const { data, loading } = useQuery(GET_NATION, {
        variables: {
            "year": year
        }
    })

    const select = data?.getNations?.filter((e) => e?.id === selectId)[0]

    const [search, setSearch] = useState([])

    const handleSearch = (query) => {
        const filteredResults = data?.getNations?.filter(item =>
            item?.name?.toLowerCase().includes(query.toLowerCase())
        );

        setSearch(filteredResults);
    };

    const GetAnswer = (id) => {
        return data?.getQuestions?.find((e) => e?.nationId === id) || null
    }

    if (loading) {
        return (
            <div className='Loading'>
                Loading...
            </div>
        )
    }
    return (
        <>
            <div className='Home'>
                <div className='HomeHead'>
                    NATIONS
                    <div className='FlexCon' />
                    <button onClick={() => setMail(true)}>Send Mail</button>
                </div>
                <div className='UserDiv'>
                    <div className='NationDivLeft'>
                        <div className='UserSearchCon'>
                            <input onChange={(e) => handleSearch(e?.target?.value)} placeholder='Search nation' />
                            <div className='FlexCon' />
                            <select value={year} onChange={(e) => setYear(e?.target?.value)}>
                                <option>2023</option>
                                <option>2024</option>
                                <option>2025</option>
                            </select>
                            {user?.role === 'super admin' ?
                                <button onClick={() => setOpen(true)}><RiAddCircleLine />Create</button>
                                : null}
                        </div>
                        <div className='UserCon'>
                            <div className='UserHead'>
                                <h4 onClick={() => setAcend(!acend)}>All Nations <b>{data?.getNations?.length}</b></h4>
                                <div className='FlexCon' />
                                <select value={area} onChange={(e) => setArea(e?.target?.value)}>
                                    <option value={""}>Select Area</option>
                                    <option>Asia Pacific</option>
                                    <option>Americas</option>
                                    <option>Africa</option>
                                    <option>EMENA</option>
                                    <option>Demo Area</option>
                                </select>
                                <select value={region} onChange={(e) => setRegion(e?.target?.value)}>
                                    <option value={""}>Select Region</option>
                                    <option>Aus/NZ</option>
                                    <option>Balkans</option>
                                    <option>Caribbean</option>
                                    <option>Central Asia</option>
                                    <option>Central Europe</option>
                                    <option>Demo Region</option>
                                    <option>East Asia</option>
                                    <option>Eastern Africa</option>
                                    <option>Eastern Europe</option>
                                    <option>Francophone</option>
                                    <option>Indian Ocean</option>
                                    <option>Latin America Central</option>
                                    <option>Latin America South</option>
                                    <option>Middle East / North Africa</option>
                                    <option>North America</option>
                                    <option>Pacific</option>
                                    <option>Portuguese Speaking Region</option>
                                    <option>South Asia</option>
                                    <option>Southeast Asia</option>
                                    <option>Southern Africa</option>
                                    <option>Southern Europe</option>
                                    <option>Western Africa</option>
                                    <option>Western Europe</option>
                                </select>
                                {/* <button onClick={()=>setOpen(true)}><RiAddCircleLine/> Create User</button> */}
                            </div>
                            <div className='NationHead2'>
                                <h2>Name</h2>
                                <h2>Status</h2>
                                {/* <h2>Region</h2> */}
                                <h2>Progress</h2>
                                <h2>BC Sign Date</h2>
                                <h2>Payment</h2>
                                {/* <h2>BC name</h2>
                                <h2>ND name</h2> */}
                            </div>
                            {search?.length > 0 ?
                                search?.map((item, index) => {
                                    return <User key={index} answer={GetAnswer(item?.id)} item={item} setSelect={setSelect} />
                                })
                                : area && region ?
                                    data?.getNations?.slice()?.sort((a, b) => {
                                        if (a.name < b.name) {
                                            return acend ? -1 : 1;
                                        }
                                        if (a.name > b.name) {
                                            return acend ? 1 : -1;
                                        }
                                        return 0;
                                    })?.filter((e) => e?.region?.name === region && e?.area?.name === area)?.map((item, index) => {
                                        return (
                                            <User key={index} answer={GetAnswer(item?.id)} item={item} setSelect={setSelect} />
                                        )
                                    })
                                    : area ?
                                        data?.getNations?.slice()?.sort((a, b) => {
                                            if (a.name < b.name) {
                                                return acend ? -1 : 1;
                                            }
                                            if (a.name > b.name) {
                                                return acend ? 1 : -1;
                                            }
                                            return 0;
                                        })?.filter((e) => e?.area?.name === area)?.map((item, index) => {
                                            return (
                                                <User key={index} answer={GetAnswer(item?.id)} item={item} setSelect={setSelect} />
                                            )
                                        })
                                        : region ?
                                            data?.getNations?.slice()?.sort((a, b) => {
                                                if (a.name < b.name) {
                                                    return acend ? -1 : 1;
                                                }
                                                if (a.name > b.name) {
                                                    return acend ? 1 : -1;
                                                }
                                                return 0;
                                            })?.filter((e) => e?.region?.name === region)?.map((item, index) => {
                                                return (
                                                    <User key={index} answer={GetAnswer(item?.id)} item={item} setSelect={setSelect} />
                                                )
                                            })
                                            :
                                            data?.getNations?.slice()?.sort((a, b) => {
                                                if (a.name < b.name) {
                                                    return acend ? -1 : 1;
                                                }
                                                if (a.name > b.name) {
                                                    return acend ? 1 : -1;
                                                }
                                                return 0;
                                            })?.map((item, index) => {
                                                return (
                                                    <User key={index} answer={GetAnswer(item?.id)} item={item} setSelect={setSelect} />
                                                )
                                            })}
                        </div>
                    </div>
                    {select ?
                        <>
                            <div className='UserDivRight'>
                                <div className='UserDivRightProfile'>
                                    <h2>{select?.name}</h2>
                                    <div className='FlexCon' />
                                    {user?.role === 'super admin' ?
                                        <div className='UserDivRightEdit' onClick={() => setEdit(select)}>
                                            <RiEdit2Line />
                                        </div>
                                        : null}
                                </div>
                                <div className='NationDivRightDiv'>
                                    <h4>Status:</h4>
                                    <h5>{select?.status || '--'}</h5>
                                </div>
                                <div className='NationDivRightDiv'>
                                    <h4>Region:</h4>
                                    <h5>{select?.region?.name || '--'}</h5>
                                </div>
                                <div className='NationDivRightDiv'>
                                    <h4>Currency:</h4>
                                    <h5>{select?.currency || '--'}</h5>
                                </div>
                                <div className='NationDivRightDiv'>
                                    <h4>Exchange:</h4>
                                    <h5>{select?.exchange || '--'}</h5>
                                </div>
                                <div className='NationDivRightDiv'>
                                    <h4>ND name:</h4>
                                    <h5>{select?.nd?.name || '--'}</h5>
                                </div>
                                <div className='NationDivRightDiv'>
                                    <h4>BC name:</h4>
                                    <h5>{select?.bc?.name || '--'}</h5>
                                </div>
                                <div className='NationDivRightDiv'>
                                    <h4>CW name:</h4>
                                    <h5>{select?.cw?.name || '--'}</h5>
                                </div>
                                <div className='NationDivRightDiv'>
                                    <h4>BC signed date</h4>
                                    <h5>{GetAnswer(select?.id)?.anual?.date_submitted ? moment(GetAnswer(select?.id)?.anual?.date_submitted * 1).format("LL") : "--"}</h5>
                                </div>
                                <Logs select={select} />
                            </div>
                        </> : null}
                </div>
            </div>
            {edit ? <Report setOpen={setEdit} open={edit} anual={GetAnswer(select?.id)} year={year} /> : null}
            <div className={open ? 'UserModal UserModalOpen' : 'UserModal'}>
                <CreateNation setOpen={setOpen} open={open} />
            </div>
            <div className={mail ? 'UserModal UserModalOpen' : 'UserModal'}>
                <SendMail open={mail} setOpen={setMail} nations={data?.getNations} answers={data?.getQuestions} />
            </div>
        </>
    )
}

function SendMail({ open, setOpen, nations, answers }) {
    const [date, setDate] = useState("")
    const [mail, setMail] = useState("")
    const [select, setSelect] = useState([])
    const [filter, setFilter] = useState("")

    const [getData, { loading, data }] = useLazyQuery(GET_EMAILS)
    const [create, createSchedule] = useMutation(CREATE_SCHEDULE, {
        refetchQueries: [
            { query: GET_SCHEDULES }
        ]
    })

    useEffect(() => {
        if (open) {
            getData()
        }
    }, [open])

    const GetAnswer = (id) => {
        return answers?.find((e) => e?.nationId === id) || null
    }

    const datas = data?.getEmails?.find((e)=> e?.id === mail)
    
    const onCreate = () => {
        const futDate = new Date(date)
        const now = new Date();
        if (futDate - now > 20000) {
            create({
                variables: {
                    "scheduleMailId": datas?.id,
                    "delay": futDate - now,
                    "mails": select,
                    "title": datas?.title,
                    "date": date
                }
            }).then(() => {
                toast.success("Email Scheduled")
                setFilter("")
                setOpen(false)
                setSelect([])
            })
        }
    }

    return (
        <div className='UserModalCon' style={{ width: 650, paddingBottom: 0 }}>
            <div className='UserModalHead'>
                Send Mail
                <div className='FlexCon' />
                {data?.getEmails?.length > 0 ?
                    <select value={mail} onChange={(e) => setMail(e?.target?.value)} style={{ width: 150, height: 30, padding: "0 10px", marginRight: 30 }}>
                        <option hidden>Select Mail</option>
                        {data?.getEmails?.map((itm, ind) => {
                            return <option key={ind} value={itm?.id}>{itm?.title}</option>
                        })}
                    </select>
                    : null}
                <RiCloseLine className='UserModalClose' size={18} onClick={() => setOpen(false)} />
            </div>
            <div className='UserModalInput' style={{ marginTop: 15 }}>
                <h2>Date and Time</h2>
                <input style={{ width: "calc(100% - 22.5px)" }} type='datetime-local' value={date} onChange={(e) => setDate(e.target.value)} placeholder='' />
            </div>
            {loading ?
                <div className='UserModalLoading'>Loading Users...</div>
                :
                <table>
                    <thead>
                        <th>Name</th>
                        <th style={{ minWidth: 120 }}>Status</th>
                        <th>ND Email</th>
                    </thead>
                    <tbody>
                        {nations?.slice()?.sort((a, b) => {
                            if (a.name < b.name) {
                                return -1;
                            }
                            if (a.name > b.name) {
                                return 1;
                            }
                            return 0;
                        })?.map((item, index) => {
                            const answer = GetAnswer(item?.id)
                            const status = answer?.anual?.chairSignature ? "BC Signed" : answer?.anual?.directorSignature ? 'ND Signed' : answer ? 'Filling' : 'Not Started'
                            if (filter && filter === status) {
                                return (
                                    <tr key={index} style={{ background: select?.find((e) => e?.email == item?.nd?.email) ? "#dfdfff" : null }} onClick={() => !item?.nd?.email ? null : select?.find((e) => e?.email == item?.nd?.email) ? setSelect(select?.filter((e) => e?.email !== item?.nd?.email)) : setSelect((prev) => [...prev, { email: item?.nd?.email, name: item?.nd?.name }])}>
                                        <td>{item?.name}</td>
                                        <td style={{ color: answer?.anual?.directorSignature ? '#2dcb72' : answer ? '#ffc82d' : '#ff6c6c' }}>{answer?.anual?.chairSignature ? "BC Signed" : answer?.anual?.directorSignature ? 'ND Signed' : answer ? 'Filling' : 'Not Started'}</td>
                                        <td>{item?.nd?.email || "--"}</td>
                                    </tr>
                                )
                            } else if (!filter) {
                                return (
                                    <tr key={index} style={{ background: select?.find((e) => e?.email == item?.nd?.email) ? "#dfdfff" : null }} onClick={() => !item?.nd?.email ? null : select?.find((e) => e?.email == item?.nd?.email) ? setSelect(select?.filter((e) => e?.email !== item?.nd?.email)) : setSelect((prev) => [...prev, { email: item?.nd?.email, name: item?.nd?.name }])}>
                                        <td>{item?.name}</td>
                                        <td style={{ color: answer?.anual?.directorSignature ? '#2dcb72' : answer ? '#ffc82d' : '#ff6c6c' }}>{answer?.anual?.chairSignature ? "BC Signed" : answer?.anual?.directorSignature ? 'ND Signed' : answer ? 'Filling' : 'Not Started'}</td>
                                        <td>{item?.nd?.email || "--"}</td>
                                    </tr>
                                )
                            }
                        })}
                    </tbody>
                </table>
            }
            <div className='UserModalBtnCon' style={{ marginTop: 20 }}>
                <select value={filter} onChange={(e) => {
                    setSelect([])
                    setFilter(e?.target?.value)
                }} style={{ width: 150 }}>
                    <option value={''}>All Nations</option>
                    <option value={'BC Signed'}>BC Signed Nations</option>
                    <option value={'ND Signed'}>ND Signed Nations</option>
                    <option value={'Filling'}>Filling Nations</option>
                    <option value={'Not Started'}>Not Started Nations</option>
                </select>
                {!filter?
                <div className='UserModalBtn' onClick={() => {
                    setSelect((prev) => [...prev, ...nations?.filter(item => !select.some((e) => e?.email === item?.nd?.email))?.map((itm) => {
                        if (itm?.nd?.email) {
                            return {
                                email: itm?.nd?.email,
                                name: itm?.nd?.name
                            }
                        }
                    })])
                }}>Add {filter ? "all " + filter : "all"}</div>
                : <div onClick={()=>{
                    const datas = nations?.map((itm)=>{
                        const answer = GetAnswer(itm?.id)
                        const status = answer?.anual?.chairSignature ? "BC Signed" : answer?.anual?.directorSignature ? 'ND Signed' : answer ? 'Filling' : 'Not Started'
                        if(filter === status){
                            return {
                                email: itm?.nd?.email,
                                name: itm?.nd?.name
                            }
                        } else {
                            return null
                        }
                    })?.filter((e)=> e)
                    setSelect(datas)
                }} className='UserModalBtn'>Select All {filter} Nations</div>}
                <div className='FlexCon' />
                <p>{select?.length} selected</p>
                <button onClick={()=>mail && select?.length > 0 && date ? console.log(mail && select?.length && date): null} style={{ opacity: mail && select?.length > 0 && date ? 1 : 0.7 }}>Schedule</button>
            </div>
        </div>
    )
}

function Logs({ select }) {
    const [getLogs, { data, loading }] = useLazyQuery(GET_LOGS)

    useEffect(() => {
        if (select) {
            getLogs({
                variables: {
                    "getLogsId": select?.id
                }
            })
        }
    }, [select])

    if (loading) {
        return (
            <div className='LogLoading'>
                Loading Logs...
            </div>
        )
    }
    return (
        <table>
            <thead>
                <tr>
                    <th>Type</th>
                    <th>Date</th>
                    <th>Log</th>
                </tr>
            </thead>
            <tbody>
                {data?.getLogs?.length == 0 ?
                    <tr>
                        <td style={{ width: 30 }}>--</td>
                        <td>--</td>
                        <td>--</td>
                    </tr>
                    :
                    data?.getLogs?.slice()?.sort((a, b) => new Date(b?.date) - new Date(a?.date))?.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td style={{ width: 30 }}>{item?.type}</td>
                                <td>{moment(item?.date).format('lll')}</td>
                                <td>{item?.log}</td>
                            </tr>
                        )
                    })}
            </tbody>
        </table>
    )
}

function Report({ setOpen, open, anual, year }) {
    const [name, setName] = useState("")
    const [status, setStatus] = useState("")
    const [exchange, setExchange] = useState("")
    const [bc, setBc] = useState("")
    const [nd, setNd] = useState("")
    const [cw, setCw] = useState("")
    const [region, setRegion] = useState("")
    const [currency, setCurrency] = useState("")
    const [payStatus, setPayStatus] = useState("")
    const [payComment, setPayComment] = useState("")

    const [getData, { loading, data }] = useLazyQuery(GET_USER)

    const [onUpdateAnual] = useMutation(UPDATE_ANUALS, {
        refetchQueries: [
            {
                query: GET_ONE_NATION,
                variables: {
                    "year": year,
                    "getNationId": open?.id
                }
            }
        ]
    })

    const [onUpdate] = useMutation(NATION_UPDATE, {
        refetchQueries: [
            {
                query: GET_ONE_NATION,
                variables: {
                    "year": year,
                    "getNationId": open?.id
                }
            }
        ]
    })
    const [load, setLoad] = useState(false)

    const [onLogCreate] = useMutation(CREATE_LOG, {
        refetchQueries: [
            {
                query: GET_LOGS,
                variables: {
                    "getLogsId": open?.id
                }
            }
        ]
    })

    useEffect(() => {
        if (open) {
            setName(open?.name)
            setStatus(open?.status)
            setExchange(open?.exchange)
            setNd(open?.nd?.id)
            setBc(open?.bc?.id)
            setCw(open?.cw?.id)
            setCurrency(open?.currency)
            setRegion(open?.region?.id)
            setPayStatus(anual?.anual?.paying_how)
            setPayComment(anual?.anual?.payment_comment)
            getData()
        }
    }, [open])

    const getUserId = (id) => {
        return data?.getUsers?.find((e) => e?.id == id) || { name: "None" }
    }
    const allStatus = open?.allStatus ? JSON.parse(open?.allStatus) : {}
    return (
        <div className={'UserModal UserModalOpen'}>
            <div className='UserModalCon' style={{ minWidth: 300 }}>
                <div className='UserModalHead'>
                    Edit Nation
                    <RiCloseLine className='UserModalClose' size={18} onClick={() => setOpen(false)} />
                </div>
                {loading ?
                    <p style={{ margin: 15 }}>Loading</p>
                    :
                    <>
                        <div className='UserModalCon1'>
                            <div>
                                <h2>Nation Name</h2>
                                <input value={name} onChange={(e) => setName(e.target.value)} placeholder='Country name' />
                            </div>
                            <div className='UserModalInput'>
                                <h2>Status</h2>
                                {/* <input value={status} onChange={(e)=>setStatus(e.target.value)} placeholder='Status'/> */}
                                <select value={status} onChange={(e) => setStatus(e.target.value)}>
                                    <option value={""}>Select Status</option>
                                    <option value={"Associate Charter"}>Associate Charter</option>
                                    <option value={"Pioneer Charter"}>Pioneer Charter</option>
                                    <option value={"Full Charter"}>Full Charter</option>
                                    <option value={"Target Charter"}>Target Charter</option>
                                    <option value={"Not currently chartered"}>Not currently chartered</option>
                                    <option value={"Conditional Charter"}>Conditional Charter</option>
                                    <option value={"Pioneer (New)"}>Pioneer (New)</option>
                                    <option value={"To Add (New)"}>To Add (New)</option>
                                    <option value={"Affiliate"}>Affiliate</option>
                                </select>
                            </div>
                        </div>
                        <div className='UserModalCon1'>
                            <div>
                                <h2>Select ND</h2>
                                <select value={nd} onChange={(e) => setNd(e?.target?.value)}>
                                    <option>Select ND</option>
                                    {data?.getUsers?.slice()?.sort((a, b) => {
                                        if (a.name < b.name) {
                                            return -1;
                                        }
                                        if (a.name > b.name) {
                                            return 1;
                                        }
                                        return 0;
                                    })?.map((item, index) => {
                                        return <option key={index} value={item?.id}>{item?.name}</option>
                                    })}
                                </select>
                            </div>
                            <div className='UserModalInput'>
                                <h2>Select BC</h2>
                                <select value={bc} onChange={(e) => setBc(e?.target?.value)}>
                                    <option>Select BC</option>
                                    {data?.getUsers?.slice()?.sort((a, b) => {
                                        if (a.name < b.name) {
                                            return -1;
                                        }
                                        if (a.name > b.name) {
                                            return 1;
                                        }
                                        return 0;
                                    })?.map((item, index) => {
                                        return <option key={index} value={item?.id}>{item?.name}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className='UserModalCon1'>
                            <div>
                                <h2>Select CW</h2>
                                <select value={cw} onChange={(e) => setCw(e?.target?.value)}>
                                    <option>Select CW</option>
                                    {data?.getUsers?.slice()?.sort((a, b) => {
                                        if (a.name < b.name) {
                                            return -1;
                                        }
                                        if (a.name > b.name) {
                                            return 1;
                                        }
                                        return 0;
                                    })?.map((item, index) => {
                                        return <option key={index} value={item?.id}>{item?.name}</option>
                                    })}
                                </select>
                            </div>
                            <div className='UserModalInput'>
                                <h2>Payment Status</h2>
                                <select value={payStatus} onChange={(e) => setPayStatus(e?.target?.value)}>
                                    <option value={""}>Select Status</option>
                                    <option value={"Outstanding"}>Outstanding</option>
                                    <option value={"Done"}>Done</option>
                                </select>
                            </div>
                        </div>
                        <div className='UserModalCon1'>
                            <div>
                                <h2>Payment Comments</h2>
                                <textarea value={payComment} onChange={(e) => setPayComment(e?.target?.value)} />
                            </div>
                        </div>
                        <div className='UserModalCon1'>
                            <div>
                                <h2>Exchange</h2>
                                <input value={exchange} onChange={(e) => setExchange(e.target.value)} placeholder='Exchange rate' />
                            </div>
                            <div className='UserModalInput'>
                                <h2>Currency</h2>
                                <input value={currency} onChange={(e) => setCurrency(e.target.value)} placeholder='Currency' />
                            </div>
                        </div>
                        <div className='UserModalCon1'>
                            <div>
                                <h2>Language</h2>
                                <select>
                                    <option value={'EN'}>English</option>
                                    <option value={'ES'}>Spanish</option>
                                    <option value={'FR'}>French</option>
                                    <option value={'PT'}>Portuguese</option>
                                    <option value={'RU'}>Russian</option>
                                    <option value={'AR'}>Arabic</option>
                                </select>
                            </div>
                            <div className='UserModalInput'>
                                <h2>Region</h2>
                                <select value={region} onChange={(e) => setRegion(e?.target?.value)}>
                                    <option>Select Region</option>
                                    {data?.getRegions?.slice()?.sort((a, b) => {
                                        if (a.name < b.name) {
                                            return -1;
                                        }
                                        if (a.name > b.name) {
                                            return 1;
                                        }
                                        return 0;
                                    })?.map((item, index) => {
                                        return <option key={index} value={item?.id}>{item?.name}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className='UserModalCon1'>
                            <div className='FlexCon' />
                            <button onClick={() => {
                                setLoad(true)
                                if (payStatus != anual?.anual.paying_how || payComment != anual?.anual.payment_comment) {
                                    onUpdateAnual({
                                        variables: {
                                            "year": year,
                                            "anual": {
                                                "paying_how": payStatus,
                                                "payment_comment": payComment,
                                                "charterId": anual?.id
                                            }
                                        }
                                    }).then((e) => {
                                        onLogCreate({
                                            variables: {
                                                "log": {
                                                    "date": new Date().toString(),
                                                    "log": payStatus != anual?.anual.paying_how ? `Payment status chanaged to ${payStatus || "None"} ` : '' + payComment != anual?.anual.payment_comment ? `Payment comment added` : '',
                                                    "nationId": open?.id,
                                                    "type": 'Nation Update'
                                                }
                                            }
                                        }).then(({ data }) => {
                                            console.log(data);
                                            setLoad(false)
                                            setOpen(false)
                                            setName("")
                                            setStatus("")
                                            setExchange("")
                                            setNd("")
                                            setBc("")
                                            setCw("")
                                            setCurrency("")
                                            setRegion("")
                                        })
                                    }).catch((err) => {
                                        setLoad(false)
                                        console.log(err);
                                    })
                                } else {
                                    onUpdate({
                                        variables: {
                                            "updateNationId": open?.id,
                                            "nation": {
                                                "bc": bc || "",
                                                "currency": currency || "",
                                                "language": open?.language || "",
                                                "exchange": exchange || "",
                                                "name": name || "",
                                                "nd": nd || "",
                                                "cw": cw || "",
                                                "status": JSON.stringify({ ...allStatus, [year]: { S: status } }),
                                                "language": open?.language || "",
                                                "region": region || "",
                                            }
                                        }
                                    }).then(() => {
                                        if (open?.nd?.id !== nd || open?.bc?.id !== bc || open?.cw?.id !== cw) {
                                            onLogCreate({
                                                variables: {
                                                    "log": {
                                                        "date": new Date().toString(),
                                                        "log": open?.nd?.id !== nd ? `ND changed from ${getUserId(open?.nd?.id)?.name} to ${getUserId(nd)?.name} ` : '' + open?.bc?.id !== bc ? `ND changed from ${getUserId(open?.bc?.id)?.name} to ${getUserId(bc)?.name} ` : '' + open?.cw?.id !== cw ? `CW changed from ${getUserId(open?.cw?.id)?.name} to ${getUserId(cw)?.name} ` : '',
                                                        "nationId": open?.id,
                                                        "type": 'Nation Update'
                                                    }
                                                }
                                            }).then(({ data }) => {
                                                console.log(data);
                                                setLoad(false)
                                                setOpen(false)
                                                setName("")
                                                setStatus("")
                                                setExchange("")
                                                setNd("")
                                                setBc("")
                                                setCw("")
                                                setCurrency("")
                                                setRegion("")
                                            })
                                        } else {
                                            setLoad(false)
                                            setOpen(false)
                                            setName("")
                                            setStatus("")
                                            setExchange("")
                                            setNd("")
                                            setBc("")
                                            setCw("")
                                            setCurrency("")
                                            setRegion("")
                                        }
                                    }).catch((err) => {
                                        setLoad(false)
                                        console.log(err);
                                    })
                                }
                            }}>{load ? "Loading" : "Update Nation"}</button>
                        </div>
                    </>}
            </div>
        </div>
    )
}

function User({ item, setSelect, answer }) {
    return (
        <div className='NationCon2' onClick={() => setSelect(item?.id)}>
            <div className='UserConImg'>
                <h2>{item?.name || '--'}</h2>
            </div>
            <h2>{item?.status || '--'}</h2>
            <h3 style={{ color: answer?.anual?.directorSignature ? '#2dcb72' : answer ? '#ffc82d' : '#ff6c6c' }}>{answer?.anual?.chairSignature ? "BC Signed" : answer?.anual?.directorSignature ? 'ND Signed' : answer ? 'Filling' : 'Not Started'}</h3>
            <h3>{answer?.anual?.date_submitted ? moment(answer?.anual?.date_submitted * 1).format("LL") : "--"}</h3>
            <h3>{answer?.anual?.paying_how || "--"}</h3>
        </div>
    )
}

function CreateNation({ setOpen, open }) {
    const [name, setName] = useState("")

    const [onCreate, { loading }] = useMutation(CREATE_NATION, {
        refetchQueries: [
            { query: GET_NATION }
        ]
    })

    return (
        <div className='UserModalCon'>
            <div className='UserModalHead'>
                Create Nation
            </div>
            <RiCloseLine className='UserModalClose' size={18} onClick={() => setOpen(false)} />
            <div className='UserModalCon1' style={{ marginRight: 15 }}>
                <div>
                    <h2>Nation Name</h2>
                    <input style={{ width: 200 }} value={name} onChange={(e) => setName(e.target.value)} placeholder='Enter Nation Name' />
                </div>
            </div>
            <div className='UserModalCon4'>
                <div className='FlexCon' />
                <button onClick={() => {
                    onCreate({
                        variables: {
                            "nation": {
                                "name": name,
                            }
                        }
                    }).then(() => {
                        setName("")
                        setOpen(false)
                    }).catch((err) => {
                        alert(err?.message)
                    })
                }}>{loading ? "Loading" : "Create Nation"}</button>
            </div>
        </div>
    )
}